import { ReduxAsyncActionsService } from '../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../types/ReduxAsyncActions.types';
import { INIT_STATE } from './SKANPostbacksConversionMapping.constants';
import type { SKANPostbacksConversionMappingState } from './SKANPostbacksConversionMapping.types';
import type { SKANPostbacksConversionMappingAction } from './actions';
import {
  GET_AVAILABLE_OPTIMIZATIONS,
  GET_CONVERSION_VALUE_MAPPING_RECOMMENDATION,
  GET_MAPPING_TEMPLATE,
  GET_MAPPING_TEMPLATES_OPTIONS,
  GET_POSTBACKS_CONVERSION_VALUE_MAPPING,
  GET_SK_AD_NETWORK_APPLICATION_STATUS,
  GET_TARGET_EVENTS_RECOMMENDATIONS,
  SET_ACTIVE_TEMPLATE_ID,
  SET_ASCENDING_ONLY,
  SET_CURRENT_CONVERSION_VALUE_MAPPING,
  SET_CURRENT_TARGET_EVENT,
  UPDATE_CONVERSION_VALUE_MAPPING,
  UPDATE_SK_AD_NETWORK_APPLICATION_STATUS,
} from './actions';

const handler = (
  state: WrappedReducer<SKANPostbacksConversionMappingState>,
  action: SKANPostbacksConversionMappingAction
): WrappedReducer<SKANPostbacksConversionMappingState> => {
  switch (action.type) {
    case GET_POSTBACKS_CONVERSION_VALUE_MAPPING.response:
      return {
        ...state,
        mappingLoading: false,
        savedMapping: action.data.mapping,
        savedTargetEvent: action.data.targetEvent,
        savedAscendingOnly: action.data.ascendingOnly,
        activeTemplateId: null,
        lastUpdate: action.data.lastUpdate,
      };

    case UPDATE_CONVERSION_VALUE_MAPPING.request:
      return {
        ...state,
        processing: true,
      };

    case UPDATE_CONVERSION_VALUE_MAPPING.response:
      const currentTime = Date.now();
      return {
        ...state,
        mappingLoading: false,
        processing: false,
        currentMapping: null,
        currentTargetEvent: '',
        currentAscendingOnly: null,
        savedMapping: action.data.mapping,
        savedTargetEvent: action.data.targetEvent,
        savedAscendingOnly: action.data.ascendingOnly,
        activeTemplateId: null,
        lastUpdate: currentTime,
      };

    case GET_SK_AD_NETWORK_APPLICATION_STATUS.response:
      return {
        ...state,
        mappingLoading: false,
        skAdNetworkEnabled: action.data.sk_ad_network_enabled,
      };

    case UPDATE_SK_AD_NETWORK_APPLICATION_STATUS.response:
      return {
        ...state,
        mappingLoading: false,
        skAdNetworkEnabled: action.data.skAdNetworkEnabled,
      };

    case GET_TARGET_EVENTS_RECOMMENDATIONS.request:
      return {
        ...state,
        targetEventsLoading: true,
      };

    case GET_TARGET_EVENTS_RECOMMENDATIONS.response:
      return {
        ...state,
        targetEventsLoading: false,
        targetEventsRecommendations: action.data || [],
      };

    case GET_CONVERSION_VALUE_MAPPING_RECOMMENDATION.request:
      return {
        ...state,
        processing: true,
      };

    case GET_CONVERSION_VALUE_MAPPING_RECOMMENDATION.response:
      return {
        ...state,
        mappingLoading: false,
        processing: false,
        currentMapping: action.data.mapping,
        skadnetworkRecommendationRevisionId: action.data.skadnetworkRecommendationRevisionId,
        activeTemplateId: null,
      };

    case SET_CURRENT_TARGET_EVENT.response:
      return {
        ...state,
        targetEventsLoading: false,
        currentTargetEvent: action.data,
      };

    case SET_CURRENT_CONVERSION_VALUE_MAPPING.response:
      return {
        ...state,
        mappingLoading: false,
        currentMapping: action.data,
        skadnetworkRecommendationRevisionId: null,
      };

    case SET_ASCENDING_ONLY.response:
      return {
        ...state,
        mappingLoading: false,
        currentAscendingOnly: action.data,
      };

    case SET_ACTIVE_TEMPLATE_ID.response:
      return {
        ...state,
        mappingLoading: false,
        activeTemplateId: action.data,
      };

    case GET_MAPPING_TEMPLATES_OPTIONS.response:
      return {
        ...state,
        processing: false,
        templateOptions: action.data,
      };

    case GET_MAPPING_TEMPLATE.request:
      return {
        ...state,
        processing: true,
      };

    case GET_MAPPING_TEMPLATE.response:
      return {
        ...state,
        processing: false,
        currentTargetEvent: '',
        currentMapping: action.data.mapping,
        activeTemplateId: action.data.id,
      };

    case GET_AVAILABLE_OPTIMIZATIONS.response:
      return {
        ...state,
        mappingOptimizationsInfo: action.data,
      };

    default:
      return state;
  }
};

const SKANPostbacksConversionMapping = ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {
  request: [GET_POSTBACKS_CONVERSION_VALUE_MAPPING],
  error: [GET_POSTBACKS_CONVERSION_VALUE_MAPPING],
});

export default SKANPostbacksConversionMapping;
